import { add, remove } from "@fluorescent/dom";
import { delayOffset, shouldAnimate } from "@/lib/animation";

const selectors = {
  items: `
    .popup__heading,
    .popup__message,
    .popup__form,
    .popup__verify-age,
    .popup__decline-age,
    .popup__footer-text
  `,
};

const classes = {
  animationRevealed: "animation--revealed",
};

export default node => {
  if (!shouldAnimate(node)) return;
  delayOffset(node, [selectors.items]);

  // Trigger the reveal animation when the drawer is opened
  function open() {
    add(node, classes.animationRevealed);
  }

  // Reset the reveal animation when the drawer is closed
  function close() {
    remove(node, classes.animationRevealed);
  }

  return {
    open,
    close,
  };
};
